// extracted by mini-css-extract-plugin
module.exports = {"LoaderSection":"Loader_LoaderSection__1bIcr","Loader":"Loader_Loader__2tJkq","object":"Loader_object__3Tyr5","loading":"Loader_loading__2RtHX"};